@use '@flixbus/honeycomb-react/dist/scss/honeycomb-helpers.scss';

.content {
  display: flex;
  flex-direction: column;
  gap: var(--hcr-spacing-4);
  padding-top: var(--hcr-spacing-3);
  padding-bottom: var(--hcr-spacing-4);
}

.clickableRow {
  cursor: pointer;

  &:hover {
    background-color: var(--hcr-bg-secondary-color);
  }

  &:focus-visible {
    outline: 2px solid var(--hcr-ui-primary-color);
    outline-offset: -2px;
  }
}

.paginationControls {
  width: 100%;
  padding: var(--hcr-spacing-3) 0 var(--hcr-spacing-2);
  border-top: 1px solid var(--hcr-line-primary-color);
}

.paginationGrid {
  width: 100%;
  row-gap: var(--hcr-spacing-2);
}

.paginationSummaryColumn,
.paginationPagerColumn,
.pageSizeColumn {
  display: flex;
  align-items: center;
  min-width: 0;
}

.paginationSummaryColumn {
  justify-content: center;
}

.paginationSummary {
  color: var(--hcr-content-secondary-color);
  font-size: var(--hcr-font-size-small);
  white-space: nowrap;
}

.paginationPagerColumn {
  justify-content: center;
}

.pageSizeColumn {
  justify-content: center;
}

.paginationSummaryColumn:empty,
.paginationPagerColumn:empty,
.pageSizeColumn:empty {
  display: none;
}

.pageSizeSelect {
  flex: 0 1 auto;
  width: max-content;
}

@include honeycomb-helpers.on-bp(md) {
  .paginationSummaryColumn:empty,
  .paginationPagerColumn:empty,
  .pageSizeColumn:empty {
    display: flex;
  }

  .paginationSummaryColumn {
    justify-content: flex-start;
  }

  .pageSizeColumn {
    justify-content: flex-end;
  }
}
